export const environment = {
  GRAPHQL_URI: 'https://askskip-system-api-dev.azurewebsites.net/',
  GRAPHQL_WS_URI: 'wss://askskip-system-api-dev.azurewebsites.net/',
  REDIRECT_URI: 'https://app-dev.askskip.ai/',
  CLIENT_ID: 'Aw8WFUANs0M8dCd2m79Z4Rg8G9HwrR91',
  CLIENT_AUTHORITY: 'auth.askskip.ai', //'dev-pb3zdwv3lfh86612.us.auth0.com',
  AUTH_TYPE: 'Auth0',
  MJ_CORE_SCHEMA_NAME: '__mj',
  NODE_ENV: 'development',
  AUTOSAVE_DEBOUNCE_MS: 1200,
  SEARCH_DEBOUNCE_MS: 800,
  MIN_SEARCH_LENGTH: 3,
  production: false,
  APP_TITLE: 'AskSkip Portal',
  STRIPE_PUBLISHABLE_KEY: 'pk_test_51QfXqtGkKOiyHe4zs8Ghi8ywvSBCE3jiaO50T7NrNEB5w83DWFQidbzSYzhBqlknLG3kbFM0YcozpM2FxQU80cTD00v1PyaRd2',
  HOTGLUE_PUBLISHABLE_KEY: 'YnEOUkLD5J8ewqZ4cqjd97Rd6PCmfVvoaElWyAUw',
  HOTGLUE_ENV_ID: 'dev.hg.memberjunction.com',
  HOTGLUE_FLOW_ID: 'ha38Qse4l'
};
